export default __webpack_public_path__ + "static/media/item3.a272af32.png";